import { amWindow } from "../types";

export const NECESSARY_COOKIES_CATEGORY_ID = "C0001";
export const ANALYTICS_COOKIES_CATEGORY_ID = "C0002";

export const togglePrivacyPreferencesDisplay = () => {
  if (amWindow.OneTrust) {
    amWindow.OneTrust.ToggleInfoDisplay();
  }
};

export const hasAnalyticsCookiesConsent = () => {
  return (
    amWindow.OnetrustActiveGroups &&
    amWindow.OnetrustActiveGroups.indexOf(ANALYTICS_COOKIES_CATEGORY_ID) !== -1
  );
};

export const shouldAllowAnalytics = (activeGroups: string) => {
  return activeGroups.includes(ANALYTICS_COOKIES_CATEGORY_ID);
};
